module.exports = __webpack_public_path__ + "static/antThing_lightbulb-986715ecb6d2d95a0a7ed26ce30c424e.png";